<template>
  <div class="ma-6">
    <div class="page-header-left">
      <h2 class="pr-3">PROFILE</h2>
      <v-spacer></v-spacer>
    </div>
    <v-row>
      <v-col cols="12" lg="2" md="2">
        <div class="borderkotak panelprofileimage mb-10">
<!--          <div class="imageavatar">-->
<!--            <img alt="av" :src="user.member.memberavatar"/>-->
<!--          </div>-->
          <ImageUpload label="Upload Profile Image" :value="user.member.memberavatar"/>
          <v-divider/>
            <div class="mr-4 ml-4 mb-10 mt-2">
              <div class="float-left mr-2"><v-icon>location_on</v-icon></div>
              <div v-if="user.province" class="float-left">{{user.city}},{{user.province}}</div>
            </div>
          <div class="ma-10"></div>
        </div>
      </v-col>
      <v-col cols="12" lg="10" md="10">
        <div class="borderkotak">
          <v-tabs  v-model="tab">
            <v-tab><v-icon class="mr-2">account_box</v-icon>Profile</v-tab>
            <v-tab><v-icon class="mr-2">settings</v-icon>API</v-tab>
            <v-tab><v-icon class="mr-2">mdi-jabber</v-icon>JabberID</v-tab>
            <v-tab><v-icon class="mr-2">settings</v-icon>Bank</v-tab>
            <v-tab><v-icon class="mr-2">security</v-icon>Keamanan</v-tab>
            <v-tab-item>
              <SettingProfile/>
            </v-tab-item>
            <v-tab-item>
              <SettingTrxBeli/>
            </v-tab-item>
            <v-tab-item>
              <JabberTrxPage/>
            </v-tab-item>
            <v-tab-item>
              <MemberBank/>
            </v-tab-item>
            <v-tab-item>
              <SecurityProfile/>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageUpload from '@/components/ImageUpload'
import SettingProfile from '@/components/SettingProfile'
import SettingTrxBeli from '@/components/SettingTrxBeli'
import MemberBank from '@/components/MemberBank'
import JabberTrxPage from '@/components/JabberTrxPage'
import SecurityProfile from '@/components/SecurityProfile'

export default {
  name: 'Profile',
  components: { SecurityProfile, JabberTrxPage, MemberBank, SettingTrxBeli, SettingProfile, ImageUpload },
  data: () => ({
    tab: 0,
    valid: false,
    provinceid: 0
  }),
  mounted () {
    this.getProvince()
    this.getIP()
  },
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('UtilsStore', ['province', 'city', 'district'])
  },
  methods: {
    ...mapActions('authentication', ['getme']),
    ...mapActions('UserStore', ['updateProfile', 'getIP']),
    ...mapActions('UtilsStore', ['getProvince', 'getCity', 'getDistrict']),
    changeprovinsi (e) {
      console.log(e.provinceid)
      this.getCity(e.provinceid)
    },
    changecity (e) {
      // this.$store.commit('Loan/setCity', e)
      this.getDistrict(e.cityid)
    },
    changekecamatan (e) {
      // this.$store.commit('Loan/setKecapatan', e)
      console.log(e)
    },
    simpan () {
      console.log(this.user.member)
      const newmember = this.user.member
      const districtid = this.user.member.districtid.districtid
      newmember.districtid = districtid

      if (typeof this.user.member.provinceid.provinceid !== 'undefined') {
        newmember.provinceid = this.user.member.provinceid.provinceid
      }

      if (typeof this.user.member.cityid.cityid !== 'undefined') {
        newmember.cityid = this.user.member.cityid.cityid
      }

      this.updateProfile(newmember)
    }

  }
}
</script>

<style scoped>
.borderkotak {
  border: thin solid rgba(0,0,0,.12);
}
.panelprofileimage {
  justify-content: center;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.imageavatar {
  position: relative;
  border: 2px solid rgba(0,0,0,.12);
  border-radius: 50%;
  width: 125px;
  justify-content: center;
  text-align: center;
  overflow: auto;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 20px;
}
.imageavatar:hover {
  background-color: rgba(0,0,0,.5);
  z-index: 10
}
.imageavatar img {
  z-index: 0;
  position: relative;
  justify-content: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
</style>
